import { useState } from "react";
import { Sparkles, Check } from "lucide-react";
import { toast } from "sonner";
import { api, inr, formatApiError } from "../lib/api";
import { PACKAGES } from "../lib/packages";

const MONTHLY = 3750;
const OFFERS = PACKAGES.filter((p) => p.key !== "monthly").map((p) => ({ ...p, saving: MONTHLY * p.months - p.price }));

export const UpgradeOffer = ({ upgrade, onRequested }) => {
  const [busy, setBusy] = useState("");
  if (!upgrade?.eligible) return null;
  const requested = upgrade.requested?.package;

  const ask = async (key) => {
    setBusy(key);
    try {
      await api.post("/portal/upgrade-interest", { package: key });
      toast.success("Thanks! The academy will get in touch about your upgrade.");
      onRequested();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy("");
  };

  return (
    <div className="mb-10" data-testid="portal-upgrade-offer">
      <h2 className="text-xs tracking-[0.25em] uppercase text-white/40 font-semibold mb-4 flex items-center gap-2">
        <Sparkles size={13} className="text-[#D4AF37]" /> Save With a Longer Package
      </h2>
      <div className="grid sm:grid-cols-3 gap-px bg-white/10 border border-[#D4AF37]/30">
        {OFFERS.map((o) => (
          <div key={o.key} className="bg-[#0A0A0A] p-6 flex flex-col" data-testid={`upgrade-card-${o.key}`}>
            <p className="text-[10px] uppercase tracking-[0.24em] text-[#D4AF37] font-semibold">{o.label}</p>
            <p className="font-heading text-3xl font-black mt-2">{inr(o.price)}</p>
            <p className="text-white/40 text-xs mt-1">{o.months} months · {inr(Math.round(o.price / o.months))}/month</p>
            <p className="text-green-300 text-sm font-semibold mt-4" data-testid={`upgrade-saving-${o.key}`}>You save {inr(o.saving)}</p>
            <p className="text-white/30 text-[11px]">vs {inr(MONTHLY)} × {o.months} months</p>
            {requested === o.key ? (
              <p className="mt-5 flex items-center gap-2 text-[#D4AF37] text-xs uppercase tracking-widest" data-testid={`upgrade-requested-${o.key}`}><Check size={14} /> Request sent</p>
            ) : (
              <button onClick={() => ask(o.key)} disabled={!!busy}
                className="mt-5 border border-[#D4AF37] text-[#D4AF37] text-xs font-bold uppercase tracking-widest px-4 py-2.5 rounded-sm hover:bg-[#D4AF37] hover:text-black transition-colors duration-200 disabled:opacity-40"
                data-testid={`upgrade-interest-${o.key}`}>
                {busy === o.key ? "Sending…" : "I'm Interested"}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
